<template>
    <b-container fluid>
        <b-tabs content-class="mt-3">
            <b-tab title="Imagenes" active>
                <div v-if="!!images && !!images.length > 0">
                    <b-row class="d-flex justify-content-center">
                        <b-col cols="8">
                            <b-carousel
                                id="carousel-1"
                                :interval="3000"
                                controls
                                indicators
                                background="#ababab"
                                img-width="100"
                                img-height="120"
                                style="text-shadow: 1px 1px 2px #333;"
                            >
                                <!-- Text slides with image -->
                                <b-carousel-slide
                                    v-for="image in images"
                                    :key="image.id"
                                    :img-src="image.photo_url"
                                ></b-carousel-slide>
                            </b-carousel>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <h4>No hay imagenes para mostrar</h4>
                </div>
            </b-tab>
            <b-tab title="Archivos">
                <div v-if="!!files && !!files.length > 0">
                    <b-row>
                        <b-col cols="12" class="files">
                            <div v-for="file in files" :key="file.id">
                                <ul>
                                    <li>
                                        <b-button variant="link" @click="downloadFile(file)">
                                            {{file.name}}
                                            <i class="fa fa-download"></i>
                                        </b-button>
                                    </li>
                                </ul>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <h4>No hay archivos para mostrar</h4>
                </div>
            </b-tab>
        </b-tabs>
    </b-container>
</template>
<script>
export default {
    props: {
        item: {
            type: [Object, Array],
        },
    },
    computed: {
        images() {
            if (!!this.item.internal_management_photos) {
                return this.item.internal_management_photos.filter(
                    item => item.type === 'image'
                )
            }
        },
        files() {
            if (!!this.item.internal_management_photos) {
                return this.item.internal_management_photos.filter(
                    item => item.type === 'file'
                )
            }
        },
    },
    data() {
        return {
            currentFiles: [],
            currentImages: [],
        }
    },
    methods: {
        downloadFile(item) {
            window.open(
                `web/v1/internal-management/${item.id}/download`,
                '_blank'
            )
        },
    },
}
</script>
<style>
.files {
    margin-left: 8%;
}
</style>